<template>
  <ModalDialog :closeable="$t('common.close')" :open.sync="IsOpen" size='large'>
    <p v-html="$t('powerIncreasePackages.explanation')"></p>
    <div class="lib__table-container lib__table-container--responsive">
      <table class="lib__table">
        <thead>
          <tr>
            <th>{{ $t('meter-box.maximumPowerGuaranteed.package') }}</th>
            <th>{{ $t('meter.maximumPowerGuaranteed') }}</th>
            <th>{{ $t('powerIncreasePackages.includingVATPrice') }}</th>
          </tr>
        </thead>
        <Loader v-if="isLoading" label />
        <tbody v-if="!isLoading">
          <template v-for="pack in meterElectricityPackages">
            <tr>
              <td :data-table-header="$t('meter-box.maximumPowerGuaranteed.package')">
                <label class="lib__field__label">{{ pack.key }}</label>
              </td>
              <td :data-table-header="$t('meter.maximumPowerGuaranteed')">
                <span class="lib__text-secondary lib__text-weight-700">
                  {{ pack.maximumKva }} {{ $t('energyProduction.kva') }}
                </span>
              </td>
              <td :data-table-header="$t('meter.maximumPowerGuaranteed')">
                <span class="lib__text-secondary lib__text-weight-700">
                  {{ getPrice(pack.powerIncreasePriceVat21) }} €
                </span>
              </td>
            </tr>
          </template>
          <tr>
            <td :data-table-header="$t('meter-box.maximumPowerGuaranteed.package')">
              <label class="lib__field__label">69+</label>
            </td>
            <td :data-table-header="$t('meter.maximumPowerGuaranteed')">
              <span class="lib__text-secondary lib__text-weight-700">
                {{ $t('meter.electricityPackage.69+') }}
              </span>
            </td>
            <td :data-table-header="$t('meter.maximumPowerGuaranteed')">
              <span class="lib__text-secondary lib__text-weight-700">
                {{ $t('new-connection-cmh.offering-selection-step.priceToBeDetermined') }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>{{ $t('powerIncreasePackages.warning') }}</p>
    <p>{{ $t('powerIncreasePackages.priceDisclaimer') }}</p>
    <p>
      <span>{{ $t('powerIncreasePackages.simulatorDisclaimerNoLink') }}</span>
      <a class="lib__no-margin lib__link__mobile--underline" :href="$t('powerIncreasePackages.simulatorUrl').toString()"
        target="_blank">{{
          $t('powerIncreasePackages.simulatorDisclaimerLink') }}</a>
    </p>

  </ModalDialog>
</template>

<script lang="ts">
import { ElectricMobilityPackageDto } from '@/models'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { pricingService } from '@/services/pricing-service'

@Component({
  name: 'power-increase-packages-modal',
})
export default class PowerIncreasePackagesModal extends Vue {
  //#region [Property]
  @Prop({ type: Boolean, required: true })
  public readonly value!: boolean
  @Prop({ type: Boolean, required: true })
  public readonly isLoading!: boolean
  //#endregion

  //#region [Data]
  @State('powerIncreasePackages', { namespace: 'eMobility/powerIncreasePackages' })
  public meterElectricityPackages!: ElectricMobilityPackageDto[]
  //#endregion

  //#region [Computed]
  public get IsOpen(): boolean {
    return this.value
  }

  public set IsOpen(val: boolean) {
    this.$emit('input', val)
  }

  public getPrice(price: number): string {
    return pricingService.formatNumberToLocaleStringFormat(price)
  }
  //#endregion
}
</script>
